import { MedisanteDevice } from '../../../../pages/Device/types';
import { SelectedDevicesStatus } from './types';

export const selectedDevicesStatusReducer = (
  status: SelectedDevicesStatus,
  context: {
    isUnlinked?: boolean;
    devices: MedisanteDevice[];
    gateways?: MedisanteDevice[];
    reset?: boolean;
  }
): SelectedDevicesStatus => {
  const { isUnlinked, devices, gateways, reset } = context;

  // d.gatewayID can be stale after (un)linking; refetched gateway sensors are the truth
  const isLinked = (d: MedisanteDevice) => {
    const gateway = gateways?.find((g) => g.id === d.gatewayID);
    return (
      !!d.gatewayID &&
      (!gateway || !!gateway.sensors?.some((s) => s.id === d.id))
    );
  };

  const initialCheck = () => {
    if (devices.some(isLinked)) {
      return SelectedDevicesStatus.LINKED_SENSORS_SELECTED;
    }
    if (
      devices.some(
        (d) =>
          gateways &&
          gateways.some(
            (g) => g.id === d.id && g.sensors && g.sensors.length > 0
          )
      )
    ) {
      return SelectedDevicesStatus.GATEWAY_SELECTED;
    }
    return SelectedDevicesStatus.ALL_SET;
  };

  if (reset) {
    return initialCheck();
  }

  switch (status) {
    case SelectedDevicesStatus.INITIAL:
      return initialCheck();

    case SelectedDevicesStatus.LINKED_SENSORS_SELECTED:
      if (isUnlinked) {
        if (
          devices.some(
            (d) =>
              gateways &&
              gateways.some(
                (g) => g.id === d.id && g.sensors && g.sensors.length > 0
              )
          )
        ) {
          return SelectedDevicesStatus.GATEWAY_SELECTED;
        }
        return SelectedDevicesStatus.ALL_SET;
      }
      return SelectedDevicesStatus.LINKED_SENSORS_SELECTED;

    case SelectedDevicesStatus.GATEWAY_SELECTED:
      if (isUnlinked) {
        return SelectedDevicesStatus.ALL_SET;
      }
      return SelectedDevicesStatus.GATEWAY_SELECTED;

    default:
      return status;
  }
};
